export enum PlanningViewMode {
  CARDS = 'cards',
  TABLE = 'table'
}
